module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_9.8b87958a.png";